<template>
  <div class="icon-post-container" @click="onClickPost">
    <icon-svg icon-class="shujia" class="icon-post"></icon-svg>
  </div>
</template>

<script>

  export default {
    name: "BookShelfIcon",
    methods: {
      onClickPost() {
        this.$router.push("/bookshelf")
      }
    }
  }

</script>

<style lang="scss" scoped>
  .icon-post-container {
    color: #000;
    width: 45px;
    font-size: 38px;
    z-index: 999;
    position: fixed;
    right: 14px;
    bottom: 105px;

    .icon-post {
      width: 100%;
      color: #fc9153;
    }
  }
</style>
